import { PRIVATE } from 'router/routes';

import { getHelpCenterLink } from 'helpers/helpCenter';
import isMobile from 'helpers/isMobile';

export const getPersonalPlanLinks = () => {
    if (isMobile.any()) {
        return `${getHelpCenterLink()}/account-access/how-do-i-log-into-the-app`;
    }

    return PRIVATE.PERSONAL_PLAN.path;
};
